import { ROOT_METADATA_NODE_ID } from '../constants'

import buildTreeHierarchy from './build-tree-hierarchy'

const addMetadataTreeRoot = (treeData, metadataType) => {
  const rootNode = {
    id: ROOT_METADATA_NODE_ID,
    name: 'Root',
    isCurationEnabled: true,
    level: 1,
    key: ROOT_METADATA_NODE_ID,
    path: '[0]',
    keyPath: [ROOT_METADATA_NODE_ID],
    parentPath: '',
    children: treeData,
  }

  return buildTreeHierarchy([rootNode], metadataType)
}

export default addMetadataTreeRoot
